import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon, styles } from 'yankees-react-utils';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const StyledSeriesVideoLink = styled(Link)`
    && {
        color: inherit;
    }
    > span {
        margin-right: 2.5px;
    }
    > b {
        margin-right: 5px;
    }
`;

const StyledSeriesWrapper = styled.div`
    margin: 2.5px 10px;
`;

const SeriesVideoLink = ({ isHomeSeries, isPitcher, game: g }) => {
    const { t: translate } = useTranslation();
    const opposingTeamId = isHomeSeries ? g.AwayTeam.TeamID : g.HomeTeam.TeamID;

    let label;
    let startingPitcherId;
    if (g.GameStatus === 1) {
        const isWin = (isHomeSeries && g.HomeScore > g.AwayScore) || (!isHomeSeries && g.AwayScore > g.HomeScore);
        label = `${isWin ? translate('baseball.abbr-win') : translate('baseball.abbr-loss')} ${g.HomeScore}-${g.AwayScore}`;
    } else {
        const starter = isHomeSeries ? g.GameProbables?.AwayStarter : g.GameProbables?.HomeStarter;
        startingPitcherId = starter?.PlayerID;
        label = starter ? `${starter.UsesInitial}. ${starter.LastName}` : translate('common.abbr-tba');
    }

    let starterTo;
    let videoTo;
    if (startingPitcherId) {
        videoTo = `/opponent/${opposingTeamId}/pitchers/${startingPitcherId}/video`;
        starterTo = `/opponent/${opposingTeamId}/pitchers/${startingPitcherId}`;
    }

    return isPitcher || !startingPitcherId
        ? (
            <StyledSeriesWrapper>
                <span>{translate('format.datetime', { val: new Date(g.GameDate), formatParams: { val: { month: 'numeric', day: 'numeric' } }, interpolation: { escapeValue: false } })}: </span>
                <b>{label}</b>
            </StyledSeriesWrapper>
        )
        : (
            <StyledSeriesWrapper>
                <span>{translate('format.datetime', { val: new Date(g.GameDate), formatParams: { val: { month: 'numeric', day: 'numeric' } }, interpolation: { escapeValue: false } })}: </span>
                <StyledSeriesVideoLink to={starterTo}>
                    <b>{label}</b>
                </StyledSeriesVideoLink>
                <Link to={videoTo}>
                    <Icon icon="video-camera" size="1.5em" color={styles.theme.background.astronaut} />
                </Link>
            </StyledSeriesWrapper>
        );
};

SeriesVideoLink.propTypes = {
    isHomeSeries: PropTypes.bool.isRequired,
    isPitcher: PropTypes.bool.isRequired,
    game: PropTypes.shape({
        GameID: PropTypes.number.isRequired,
        GameDate: PropTypes.string.isRequired,
        GameStatus: PropTypes.number.isRequired,
        HomeScore: PropTypes.number,
        AwayScore: PropTypes.number,
        HomeTeam: PropTypes.shape({
            TeamID: PropTypes.number.isRequired,
        }).isRequired,
        AwayTeam: PropTypes.shape({
            TeamID: PropTypes.number.isRequired,
        }).isRequired,
    }).isRequired,
};

export default SeriesVideoLink;
